/* ★ v29.35（用户定案）：`dbViewConfig.vue` 按步骤拆分（`dbView/configSteps/`）时抽出的
   跨步骤共用小工具。只放**两个以上步骤都会用**的纯函数，只被单步用到的就近放在该组件里。 */

/* 兼容 getApiData 可能的返回结构（直接对象/数组 或 {data:...}）
   ⚠️ v29.23 的血泪教训：自建接口的响应负载键**不要叫 `data`**——宿主 request 层会直接回吐
   result 负载，此处以 `res.data` 判信封，负载键恰好也叫 data 时行数组会被二次解包。 */
export const extractData = (res: any) => {
  if (res && typeof res === 'object' && !Array.isArray(res) && res.data !== undefined)
    return res.data;
  return res;
};

/** 一律归一成数组（拿不到就返回空数组，调用方不用再判） */
export const toList = (res: any): any[] => {
  const d = extractData(res);
  return Array.isArray(d) ? d : [];
};
